import React, { Fragment } from 'react';
import { useRouter } from 'next/router';

import { AlertDialog, ContentDialog } from '@reckon-web/modal-dialog';
import { Text } from '@reckon-web/text';

import { ViewJob } from './view-job';

export type ViewJobDialogDoCloseArgs = { bypassDirtyCheck: boolean };

export const ViewJobDialog: React.FC = () => {
  const router = useRouter();
  const [isOpen, setIsOpen] = React.useState(false);
  const [shouldPromptUnsaved, setShouldPromptUnsaved] =
    React.useState<boolean>();
  const [isPromptingUnsaved, setIsPromptingUnsaved] = React.useState(false);

  const jobId = router.query.job;

  React.useEffect(() => {
    if (router.query.job) setIsOpen(true);
  }, [router.query.job]);

  const onClose = (args: ViewJobDialogDoCloseArgs) => {
    if (!args.bypassDirtyCheck && shouldPromptUnsaved) {
      setIsPromptingUnsaved(true);
      return;
    }

    closeDialog();
  };

  const closeDialog = () => {
    delete router.query.job;
    router.push({ pathname: router.pathname, query: router.query }, undefined, {
      shallow: true,
    });
    setIsOpen(false);
  };

  return (
    <Fragment>
      <ContentDialog
        size="small"
        isOpen={isOpen}
        onClose={() => onClose({ bypassDirtyCheck: false })}
        css={{ width: '95vw', height: '95vh', overflow: 'hidden' }}
      >
        {jobId && (
          <ViewJob
            // this array check is weird. In theory, the url can have more than one jobid in it
            // in practice we won't do that, but just in case someone is getting fresh with the url, just take the first one
            jobId={Array.isArray(jobId) ? jobId[0] : jobId}
            doClose={onClose}
            setShouldPromptUnsaved={setShouldPromptUnsaved}
          />
        )}
      </ContentDialog>
      <AlertDialog
        isOpen={Boolean(isPromptingUnsaved)}
        actions={{
          confirm: {
            label: 'Yes, discard',
            action: () => {
              setIsPromptingUnsaved(false);
              closeDialog();
            },
          },
          cancel: {
            label: `Continue editing`,
            action: () => setIsPromptingUnsaved(false),
          },
        }}
        title="Discard changes?"
        tone="critical"
      >
        <Text>Changes you've made so far will not be saved.</Text>
      </AlertDialog>
    </Fragment>
  );
};
